import React, { useState, useRef, useEffect } from 'react';
import { getComplaintTatListSummary } from '../../../utils/complaintTatFormatter';

function TatStageRow({ stage, line }) {
  if (!line) return null;

  const slaMark = line.slaBadge
    ? line.slaBadge.met
      ? { symbol: '✓', className: 'tat-sla-mark tat-sla-mark--met', label: 'Within SLA' }
      : { symbol: '⚠', className: 'tat-sla-mark tat-sla-mark--missed', label: 'Out of SLA' }
    : null;

  return (
    <div className={`tat-stage-row tat-${line.state}`}>
      <span className="tat-stage-row-label">{stage}</span>
      <span className="tat-stage-row-sep" aria-hidden="true">
        ·
      </span>
      <span className="tat-stage-row-duration">{line.primary}</span>
      {slaMark && (
        <span className={slaMark.className} aria-label={slaMark.label}>
          {slaMark.symbol}
        </span>
      )}
    </div>
  );
}

function ComplaintTatListCell({ complaint }) {
  const tat = getComplaintTatListSummary(complaint);
  const [policyOpen, setPolicyOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    if (!policyOpen) return undefined;

    const handleOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setPolicyOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [policyOpen]);

  if (!tat.hasTat) {
    return <span className="complaint-tat-na">—</span>;
  }

  const policyLines = tat.policyTooltip ? tat.policyTooltip.split('\n') : [];

  const stopRowNav = (e) => {
    e.stopPropagation();
  };

  const togglePolicy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPolicyOpen((open) => !open);
  };

  return (
    <div
      className="complaint-tat-cell-inner"
      ref={popoverRef}
      onClick={stopRowNav}
      onMouseDown={stopRowNav}
    >
      {tat.policyTooltip && (
        <div className="complaint-tat-head">
          <button
            type="button"
            className="complaint-tat-info-btn"
            onClick={togglePolicy}
            onMouseDown={stopRowNav}
            aria-expanded={policyOpen}
            aria-label="View applicable TAT policy"
          >
            <span className="complaint-tat-info-icon" aria-hidden="true">
              ℹ️
            </span>
            <span className="complaint-tat-info-text">Policy</span>
          </button>
          {policyOpen && (
            <div
              className="complaint-tat-popover"
              role="dialog"
              aria-label="Applicable TAT policy"
              onClick={stopRowNav}
              onMouseDown={stopRowNav}
            >
              {policyLines.map((line, i) => (
                <div
                  key={line}
                  className={i === 0 ? 'complaint-tat-popover-title' : 'complaint-tat-popover-line'}
                >
                  {line}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="complaint-tat-stacked">
        <TatStageRow stage="Ack" line={tat.ack} />
        <TatStageRow stage={tat.closureStageLabel} line={tat.closure} />
      </div>
    </div>
  );
}

export default ComplaintTatListCell;
